import { Input, Tabs } from "antd";
import { useState } from "react";

const SearchWithTabs = () => {
  const [query, setQuery] = useState("");
  const [activeTab, setActiveTab] = useState("symbols");

  const handleSearch = (value) => {
    setQuery(value);
    // Trigger search logic here based on `activeTab`
  };

  return (
    <div
      style={{
        background: "#fff",
        padding: "20px",
        borderRadius: "12px",
        width: "60vw",
        maxWidth: "80vw",
        margin: "auto",
        marginTop: "20%",
        boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
      }}
    >
      <Input.Search
        placeholder="Search stocks, ideas, people..."
        enterButton
        size="large"
        onSearch={handleSearch}
        onChange={(e) => setQuery(e.target.value)}
        style={{ marginBottom: 20 }}
      />

      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key)}
        left
        items={[
          { label: "Symbols", key: "symbols" },
          { label: "Sectors", key: "sectors" },
          { label: "Company-Analysis", key: "analysis" },
          { label: "Screens", key: "screens" },
          { label: "Quarterly-Earnings", key: "quarterly-earnings" },
        ]}
      />

      <div style={{ marginTop: 20 }}>
        {/* Render results here based on `activeTab` and `query` */}
        {/* You can map through result list and show styled cards or rows */}
        <p>
          Showing results for "{query}" in {activeTab}
        </p>
      </div>
    </div>
  );
};

export default SearchWithTabs;
